export default __webpack_public_path__ + "static/media/woman-dark-bg.df75768b.png";